import { ActionTrigger } from './ActionTrigger';
import { ThreeDotsTrigger } from './ThreeDotsTrigger';
export var menuTriggers = {
  ActionTrigger,
  ThreeDotsTrigger
};
//# sourceMappingURL=index.js.map